export const generateLayerId = () => {
  return `layer-${Date.now()}`;
};